// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"487":"90ed9ee7","990":"719c4df1"}[chunkId] + ".chunk.js";
};